import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CodeEntry from './pages/CodeEntry';
import Practice from './pages/Practice';
import Test from './pages/Test';
import Results from './pages/Results';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<CodeEntry />} />
          <Route path="/practice" element={<Practice />} />
          <Route path="/test/:code" element={<Test />} />
          <Route path="/results/:code" element={<Results />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
